import api from '@pray/shared/utils/api';

export async function getAllLocales({ artistId } = {}) {
  const url = `/web/studio/locales`;
  const params = {};

  if (artistId) {
    params.artist_id = artistId;
  }

  const response = await api.executeGetRequest(url, params);
  return response.data;
}
